export const DEFAULT_SIDEBAR_WIDTH_PX = 265;
export const MIN_SIDEBAR_WIDTH_PX = 220;
export const MAX_SIDEBAR_WIDTH_PX = 420;

const parsePxValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }

  return Math.round(parsed);
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const resolveSidebarWidthPx = ({ configWidthPx, envWidthOverride }) => {
  const parsedConfigWidth = parsePxValue(configWidthPx);
  const parsedOverrideWidth = parsePxValue(envWidthOverride);

  const sourceWidth = parsedOverrideWidth ?? parsedConfigWidth ?? DEFAULT_SIDEBAR_WIDTH_PX;
  return clamp(sourceWidth, MIN_SIDEBAR_WIDTH_PX, MAX_SIDEBAR_WIDTH_PX);
};
